import { useQuery } from '@tanstack/vue-query';

import { keys } from '../keys';

export const useVersion = (refetchInterval: number) => useQuery({
  ...keys.version.currentVersion,
  refetchInterval,
});
